import { dateTimeFormatFR } from '../Utils/Functions';
import * as actions from './Actions';

export const NotificationsReducer = (state, action) => {
    switch (action.type) {
        case actions.ADD_NOTIFICATION:
            // Return original state if no payload
            if (!action.payload) return state;

            // Create a copy of the state to work with
            const newState = [...state];
            
            // Ensure notifications is always an array
            const notifications = Array.isArray(action.payload) ? action.payload : [action.payload];
            
            // Process each notification
            for (let data of notifications) {
                // Skip invalid data
                if (!data || typeof data !== 'object') continue;
                
                // Skip if notification already exists
                if (newState.some(n => n.id === data.id)) continue;
                
                // Format dates
                let createdAtStr = "inconnu";
                let updatedAtStr = "inconnu";
                
                try {
                    if (data.createdAt) {
                        createdAtStr = dateTimeFormatFR.format(new Date(data.createdAt));
                    }
                    if (data.updatedAt) {
                        updatedAtStr = dateTimeFormatFR.format(new Date(data.updatedAt));
                    }
                    if (createdAtStr === updatedAtStr) updatedAtStr = 'jamais';
                } catch (error) {
                    // Silent catch
                }
                
                // Create and add the new notification
                const newNotification = {
                    id: data.id || Date.now().toString(),
                    type: data.type || 'info',
                    category: data.category || 'general',
                    title: data.title || '',
                    message: data.message || '',
                    isRead: Boolean(data.isRead),
                    data: data.data || {},
                    createdAt: data.createdAt || new Date().toISOString(),
                    updatedAt: data.updatedAt,
                    createdAtStr: createdAtStr,
                    updatedAtStr: updatedAtStr,
                    employeeId: data.employeeId,
                    attendanceRecordId: data.attendanceRecordId,
                    absenceId: data.absenceId,
                    expiresAt: data.expiresAt,
                    userId: data.userId,
                    agentId: data.agentId,
                    companyId: data.companyId
                };
                
                newState.push(newNotification);
            }
            return newState;

        case actions.DELETE_NOTIFICATION:
            return state.filter(notification => notification.id !== action.id);

        case actions.MARK_SEEN_NOTIFICATION:
            return state.map(notification =>
                notification.id === action.id ? { ...notification, isRead: true } : notification
            );

        case actions.MARK_UNSEEN_NOTIFICATION:
            return state.map(notification =>
                notification.id === action.id ? { ...notification, isRead: false } : notification
            );

        case actions.MARK_ALL_SEEN_NOTIFICATIONS:
            return state.map(notification => ({ ...notification, isRead: true }));

        case actions.CLEAR_NOTIFICATIONS_LIST:
            return [];

        case 'MARK_NOTIFICATIONS_SEEN':
            return state.map(notification =>
                action.payload?.includes(notification.id) 
                    ? { ...notification, isRead: true } 
                    : notification
            );

        case 'SET_NOTIFICATIONS':
            return action.payload || [];

        default:
            return state;
    }
};